import { IStorageService } from "../../platform/services/storage/StorageService";
import { FileProvider } from "../file/FileProvider";

export const removeFile = async (
    s3FileName: string, 
    storageService: IStorageService, 
    fileProvider: FileProvider,
    tenantId: string
) => {
    try {
        fileProvider.clearCacheFor(s3FileName);
        await storageService.delete(s3FileName, tenantId);
    } catch (error: any) {
        console.log("Error removing file: ", error);
    }
};